import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import './Products.css';

function LineIcon({ id, color, size = 32 }) {
  const icons = {
    healthcare: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><rect x="20" y="6" width="8" height="36" rx="4" fill={color} opacity="0.2"/><rect x="6" y="20" width="36" height="8" rx="4" fill={color} opacity="0.2"/><rect x="22" y="8" width="4" height="32" rx="2" fill={color}/><rect x="8" y="22" width="32" height="4" rx="2" fill={color}/></svg>,
    personalcare: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><path d="M24 40 C24 40 8 30 8 18 C8 12 13 7 19 7 C21.5 7 23.5 8 24 9 C24.5 8 26.5 7 29 7 C35 7 40 12 40 18 C40 30 24 40 24 40Z" fill={color} opacity="0.2"/><path d="M24 38 C24 38 10 28.5 10 18 C10 13.5 14 9 19 9 C21.5 9 23 10 24 11.5 C25 10 26.5 9 29 9 C34 9 38 13.5 38 18 C38 28.5 24 38 24 38Z" fill={color}/></svg>,
    babycare: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><ellipse cx="24" cy="28" rx="12" ry="14" fill={color} opacity="0.2"/><ellipse cx="24" cy="28" rx="9" ry="11" fill={color}/><ellipse cx="24" cy="15" rx="5" ry="6" fill={color} opacity="0.7"/><rect x="21" y="8" width="6" height="4" rx="2" fill={color} opacity="0.5"/></svg>,
    dental: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><path d="M18 10 C12 10 10 15 10 18 C10 25 16 31 18 38 C19 38 20 35 22 31 C23 28 23.5 26 24 26 C24.5 26 25 28 26 31 C28 35 29 38 30 38 C32 31 38 25 38 18 C38 15 36 10 30 10 C27 10 25.5 12 24 12 C22.5 12 21 10 18 10Z" fill={color}/><path d="M16 8 C10 8 8 14 8 18 C8 26 14 32 16 40 C17 40 18 36 20 32 C21 28 23 26 24 26 C25 26 27 28 28 32 C30 36 31 40 32 40 C34 32 40 26 40 18 C40 14 38 8 32 8 C28 8 26 10 24 10 C22 10 20 8 16 8Z" fill={color} opacity="0.2"/></svg>,
    laboratory: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><rect x="18" y="6" width="12" height="30" rx="6" fill={color} opacity="0.2"/><rect x="20" y="8" width="8" height="26" rx="4" fill={color}/><rect x="16" y="34" width="16" height="8" rx="4" fill={color} opacity="0.7"/><circle cx="24" cy="14" r="3" fill="white"/></svg>,
    physiotherapy: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><circle cx="24" cy="12" r="4" fill={color}/><circle cx="24" cy="12" r="6" fill={color} opacity="0.3"/><path d="M16 22 C16 19 19 17 24 17 C29 17 32 19 32 22 L32 30 C32 31.5 31 33 29 33 L19 33 C17 33 16 31.5 16 30 Z" fill={color}/><path d="M14 22 C14 18 18 16 24 16 C30 16 34 18 34 22 L34 30 C34 32 32 34 30 34 L18 34 C16 34 14 32 14 30 Z" fill={color} opacity="0.2"/></svg>,
    hospitality: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><path d="M10 20 C10 20 10 10 24 10 C38 10 38 20 38 20 L38 26 C38 34 32 40 24 40 C16 40 10 34 10 26 Z" fill={color} opacity="0.2"/><path d="M12 20 C12 20 12 12 24 12 C36 12 36 20 36 20 L36 26 C36 33 31 38 24 38 C17 38 12 33 12 26 Z" fill={color}/><path d="M18 20 L30 20" stroke="white" strokeWidth="2" strokeLinecap="round"/><path d="M16 25 L32 25" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>,
    industrial: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><rect x="10" y="22" width="28" height="16" rx="2" fill={color}/><rect x="8" y="20" width="32" height="20" rx="3" fill={color} opacity="0.2"/><path d="M16 22 L16 16 L24 10 L32 16 L32 22" fill={color} opacity="0.5"/><rect x="20" y="30" width="8" height="8" rx="1" fill="white" opacity="0.6"/></svg>,
    emergency: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><path d="M24 6 L28 18 L40 18 L31 26 L34 38 L24 31 L14 38 L17 26 L8 18 L20 18 Z" fill={color} opacity="0.2"/><path d="M24 8 L27.5 19 L39 19 L30 26.5 L33 38 L24 32 L15 38 L18 26.5 L9 19 L20.5 19 Z" fill={color}/></svg>,
    athlete: <svg viewBox="0 0 48 48" fill="none" width={size} height={size}><circle cx="24" cy="24" r="16" fill={color} opacity="0.2"/><circle cx="24" cy="24" r="12" fill={color}/><path d="M24 16 L26.5 21.5 L33 22.5 L28.5 27 L29.5 33.5 L24 30.5 L18.5 33.5 L19.5 27 L15 22.5 L21.5 21.5 Z" fill="white"/></svg>,
  };
  return icons[id] || icons.healthcare;
}

export default function Products() {
  const { productLines } = useData();
  const [searchParams] = useSearchParams();
  const lineParam = searchParams.get('line');
  const [activeLine, setActiveLine] = useState(lineParam || '');
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    if (lineParam) setActiveLine(lineParam);
  }, [lineParam]);

  // Close modal on ESC key
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setSelectedProduct(null); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  const currentLine = productLines.find(l => l.id === activeLine) || productLines[0] || null;

  if (!productLines.length || !currentLine) return (
    <div style={{ padding: '120px 40px', textAlign: 'center', color: '#777' }}>
      Loading products...
    </div>
  );

  return (
    <main className="products-page">
      {/* Page Header */}
      <section className="products-hero" style={{ '--line-color': currentLine.color }}>
        <div className="container">
          <div className="ph-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Products</span>
          </div>
          <h1 className="ph-title">Our Product Portfolio</h1>
          <p className="ph-desc">Ten specialised sectors covering every healthcare, consumer, and utility need.</p>
        </div>
      </section>

      {/* Tabs */}
      <div className="products-tabs-wrapper">
        <div className="products-tabs container">
          {productLines.map(line => (
            <button key={line.id}
              className={`tab-btn${activeLine === line.id ? ' active' : ''}`}
              style={{ '--tab-color': line.color }}
              onClick={() => { setActiveLine(line.id); setSelectedProduct(null); }}>
              <LineIcon id={line.id} color={activeLine === line.id ? line.color : '#888'} size={20} />
              <span>{line.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Line Detail */}
      <section className="line-detail container">
        <div className="line-info" style={{ '--line-color': currentLine.color, '--line-light': currentLine.lightColor }}>
          <div className="line-info-text">
            <div className="line-badge" style={{ color: currentLine.color, background: currentLine.lightColor }}>
              <LineIcon id={currentLine.id} color={currentLine.color} size={20} />
              {currentLine.name}
            </div>
            <h2>{currentLine.subtitle}</h2>
            <p>{currentLine.description}</p>
            <Link to="/contact" className="btn-primary" style={{ background: currentLine.color }}>
              Enquire About {currentLine.name}
            </Link>
          </div>
          <div className="line-info-img">
            <img src={currentLine.image} alt={currentLine.name} />
            <div className="line-img-count">
              <span>{currentLine.products.length}</span>
              <small>Products</small>
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="products-grid">
          {currentLine.products.map((product, i) => (
            <div key={i}
              className="product-card"
              style={{ '--pc-color': currentLine.color, '--pc-light': currentLine.lightColor, animationDelay: `${i * 0.05}s` }}
              onClick={() => setSelectedProduct(i)}>
              <div className="pc-header">
                <div className="pc-num">{String(i + 1).padStart(2, '0')}</div>
                <div className="pc-expand">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M15 3h6v6M14 10l6.1-6.1M9 21H3v-6M10 14l-6.1 6.1"/>
                  </svg>
                </div>
              </div>
              <div className="pc-thumb">
                <img src={product.image} alt={product.name}
                  onError={e => { e.target.src = currentLine.image; }}/>
              </div>
              <h4 className="pc-name">{product.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* Product Modal Popup */}
      {selectedProduct !== null && (
        <div className="product-modal-overlay" onClick={() => setSelectedProduct(null)}>
          <div className="product-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedProduct(null)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
            <div className="modal-inner">
              <div className="modal-img">
                <img
                  src={currentLine.products[selectedProduct]?.image}
                  alt={currentLine.products[selectedProduct]?.name}
                  onError={e => { e.target.src = currentLine.image; }}
                />
                <div className="modal-img-badge" style={{ background: currentLine.color }}>
                  {currentLine.name}
                </div>
              </div>
              <div className="modal-info">
                <div className="modal-num" style={{ color: currentLine.color }}>
                  {String(selectedProduct + 1).padStart(2, '0')}
                </div>
                <h2 className="modal-title">{currentLine.products[selectedProduct]?.name}</h2>
                <p className="modal-desc">{currentLine.products[selectedProduct]?.desc}</p>
                <div className="modal-meta">
                  <div className="modal-meta-item">
                    <span className="modal-meta-label">Material</span>
                    <span className="modal-meta-value">{currentLine.products[selectedProduct]?.material}</span>
                  </div>
                  <div className="modal-meta-item">
                    <span className="modal-meta-label">Application</span>
                    <span className="modal-meta-value">{currentLine.products[selectedProduct]?.use}</span>
                  </div>
                </div>
                <Link
                  to="/contact"
                  className="modal-enquire"
                  style={{ background: currentLine.color }}
                  onClick={() => setSelectedProduct(null)}
                >
                  Enquire About This Product →
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bottom CTA */}
      <section className="products-cta">
        <div className="container">
          <p>Looking for a specific product or custom specification?</p>
          <Link to="/contact" className="btn-primary">Contact Our Team</Link>
        </div>
      </section>

    </main>
  );
}
